import React from 'react';
import Icon from '../../../components/AppIcon';

const tabs = [
  {
    id: 'receipts',
    label: 'صف بررسی رسیدها',
    icon: 'Receipt',
    description: 'تایید یا رد رسیدهای آپلود شده مشتریان',
  },
  {
    id: 'pending',
    label: 'تایید/رد رزروها',
    icon: 'ClipboardCheck',
    description: 'مدیریت کل رزروهای بلاتکلیف',
  },
  {
    id: 'today',
    label: 'رزروهای امروز',
    icon: 'CalendarDays',
    description: 'لیست تمام نوبت‌های امروز سالن',
  },
];

const BookingTabNavigation = ({ activeTab, onTabChange }) => {
  return (
    <div className="w-full" dir="rtl">
      {/* Desktop view */}
      <div className="hidden sm:grid grid-cols-3 gap-3 bg-muted/30 border border-border p-1.5 rounded-xl">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex flex-col items-center gap-1.5 p-3 rounded-lg text-center transition-all duration-200
                ${
                  isActive
                    ? 'bg-card text-foreground border border-border shadow-sm'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted/55'
                }
              `}
            >
              <div className="flex items-center gap-2">
                <Icon name={tab.icon} size={18} className={isActive ? 'text-primary' : ''} />
                <span className="text-sm font-semibold">{tab.label}</span>
              </div>
              <span className="text-[10px] opacity-80 font-normal hidden lg:inline">
                {tab.description}
              </span>
            </button>
          );
        })}
      </div>

      {/* Mobile view */}
      <div className="grid sm:hidden grid-cols-3 gap-2 bg-muted/40 p-1 rounded-lg">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex flex-col items-center gap-1 p-2 rounded-md text-center text-xs transition-colors duration-150
                ${
                  isActive
                    ? 'bg-card text-foreground shadow-sm font-semibold'
                    : 'text-muted-foreground hover:text-foreground'
                }
              `}
            >
              <Icon name={tab.icon} size={16} className={isActive ? 'text-primary' : ''} />
              <span className="mt-0.5 scale-90">{tab.label.split(' ')[0]}...</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BookingTabNavigation;
